<template>
  <v-container fluid class="px-4 px-md-8">
    <v-overlay v-if="loadingPagos" opacity="0">
      <v-container class="d-flex align-center justify-center flex-column">
        <h1 class="text--grey grey--text text--darken-4 mb-10">Cargando...</h1>

        <v-progress-circular size="50" width="8" indeterminate color="grey darken-4"></v-progress-circular>
      </v-container>
    </v-overlay>
    <template v-else>
      <h1 class="headline font-weight-bold mb-8">Mis formas de pago</h1>
      <v-card max-width="800" class="mx-auto" flat>
        <v-list two-line>
          <v-list-item-group v-model="selected" multiple active-class="pink--text">
            <template v-for="(card, i) in formasFiltradas">
              <v-list-item :key="i" :value="card">
                <template v-slot:default="{ active }">
                  <v-list-item-icon>
                    <v-icon class="display-1 headline" color="black">mdi-credit-card-outline</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>
                      <span class="text-uppercase pr-3">{{card.card.brand}}</span>
                      Que termina en ... {{ $t(card.card.last4) }}
                    </v-list-item-title>
                    <v-list-item-subtitle>Expira en: {{card.card.exp_month}} / {{card.card.exp_year}}</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-menu transition="scale-transition" bottom left>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>

                      <v-list width="256">
                        <v-list-item
                          v-for="(item, i) in menuDireccion"
                          :key="i"
                          @click="eliminar(card)"
                        >
                          <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-list-item-action>
                </template>
              </v-list-item>

              <v-divider></v-divider>
            </template>
          </v-list-item-group>
        </v-list>
      </v-card>
      <!-- <v-row>
        <v-col>
          <h1 class="headline font-weight-bold">Mis formas de pago</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" offset-xs="0" sm="10" offset-sm="1" md="8" offset-md="2" >
          <v-list class="pa-0 ma-0">
            <v-list-item class="py-4" v-for="(card, i) in formasFiltradas" :key="i" :value="card">
              <template v-slot:default="{ active }">
                <v-list-item-icon>
                  <v-icon class="display-1 headline" color="black">mdi-credit-card-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>
                    <span class="text-uppercase pr-3">{{card.card.brand}}</span>
                    Que termina en ... {{ $t(card.card.last4) }}
                  </v-list-item-title>
                  <v-list-item-subtitle>Expira en: {{card.card.exp_month}} / {{card.card.exp_year}}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-menu transition="scale-transition" bottom left>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>

                    <v-list width="256">
                      <v-list-item
                        v-for="(item, i) in menuDireccion"
                        :key="i"
                        @click="deleteFormaPago(card)"
                      >
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </template>
              <v-divider></v-divider>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>-->
    </template>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import direccionCard from "@/components/Pedidos/pedir_direccionCard.vue";
export default {
  components: {
    direccionCard
  },
  data() {
    return {
      selected: null,
      loadingPagos: false,
      menuDireccion: [{ title: "Eliminar" }]
    };
  },
  computed: {
    ...mapState({
      formasPago: state => state.auth.formasPago
    }),
    formasFiltradas: function() {
      let _vue = this;
      let res = [];
      return this.formasPago;
    }
  },
  methods: {
    ...mapActions({
      getFormasPagoAction: "auth/getFormasPago"
    }),
    eliminar(obj) {
      this.$confirm(
        "¿Desea eliminar definitivamente esta forma de pago? Esta acción es irreversible?",
        {
          buttonTrueText: "Aceptar",
          buttonFalseText: "No",
          color: "warning",
          icon: "warning",
          width: 350
        }
      ).then(res => {
        if (res) {
          this.deleteFormaPago(obj);
        }
      });
    },
    deleteFormaPago(obj) {
      this.loadingPagos = true;
      const _vm = this;
      this.$store
        .dispatch("auth/removeFormaPago", obj)
        .then(r => {
          console.log(r);
          if (!r.data.ok) Promise.reject(r.data.msj);
          return this.getFormasPagoAction();
        })
        .then(() => {
          this.$store.commit(
            "snackbar/setMensajeSuccess",
            { msj: "Tarjeta eliminada." },
            { root: true }
          );
        })
        .catch(e => {
          this.$store.commit(
            "snackbar/setMensajeSuccess",
            { msj: e },
            { root: true }
          );
        })
        .finally(() => (_vm.loadingPagos = false));
    },
    getFormasPago() {
      this.loadingPagos = true;
      const _vm = this;
      return this.getFormasPagoAction().finally(
        () => (_vm.loadingPagos = false)
      );
    }
  },
  mounted() {
    this.getFormasPago();
  }
};
</script>

<style>
.border {
  border: 1px solid #000;
}
</style>
